import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';

import NumberInput from 'admin/components/atoms/NumberInput';
import QRCode from 'qrcode.react';
import { Button } from '../atoms/Buttons';
import CopyToClipboard from '../atoms/CopyToClipboard';
import Label from '../atoms/Label';
import TextBox from '../atoms/TextBox';
import { downloadQrCodeImage } from '../organisms/QrCodePopup';

type Props = {
  uri: string;
  name: string;
  qrSize?: number;
  showUrl?: boolean;
  urlAsLabel?: boolean;
  copyable?: boolean;
};

const QrCodeDrawerContentWrapper = styled.div`
  margin: 10px;

  ${NumberInput} {
    margin: 10px 0;
    display: block;
    width: 100%;
  }
`;

const NumberInputLabel = styled.div``;

const NumberInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  ${Button} {
    margin-top: 0;
  }
`;

const UrlWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

const BaseQrCodeDrawer = ({
  uri,
  name,
  qrSize = 256,
  showUrl = false,
  urlAsLabel,
  copyable,
}: Props) => {
  const [size, setSize] = useState(qrSize);

  return (
    <QrCodeDrawerContentWrapper>
      <QRCode id="canvas" value={uri} size={size || 0} includeMargin />
      <NumberInputWrapper>
        <NumberInputLabel>サイズ(px)</NumberInputLabel>
        <NumberInput
          value={`${size}`}
          setValue={(s) => {
            const sizeInt = parseInt(s, 10);
            setSize(sizeInt >= 1 ? sizeInt : 1);
          }}
        />
        <Button onClick={() => downloadQrCodeImage(name)}>ダウンロード</Button>
      </NumberInputWrapper>
      {showUrl && (
        <UrlWrapper>
          {urlAsLabel ? (
            <Label>{uri}</Label>
          ) : (
            <TextBox value={uri} size={80} disabled style={{ backgroundColor: 'white' }} />
          )}
          {copyable && <CopyToClipboard text={uri} />}
        </UrlWrapper>
      )}
    </QrCodeDrawerContentWrapper>
  );
};

BaseQrCodeDrawer.propTypes = {
  uri: PropTypes.string.isRequired,
};

const QrCodeDrawer = styled(BaseQrCodeDrawer)`
  ${QrCodeDrawerContentWrapper} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export default QrCodeDrawer;
